import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";

import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import { useI18n } from "vue-i18n";

//imports for app initialization
// import MockAdapter from "@/core/mock/MockService";
//import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import 'v-calendar/dist/style.css';
import SetupCalendar from "v-calendar"

// Setup plugin for defaults or `$screens` (optional)


import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";

export const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(SetupCalendar, {})

//ApiService.init(app);
//MockAdapter.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");